var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeInvisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41317 9.41368C9.23007 9.61017 9.00927 9.76778 8.76394 9.87709C8.51861 9.9864 8.25377 10.0452 7.98523 10.0499C7.71669 10.0547 7.44995 10.0053 7.20091 9.90467C6.95188 9.80408 6.72565 9.65436 6.53573 9.46444C6.34582 9.27453 6.1961 9.0483 6.09551 8.79927C5.99492 8.55023 5.94552 8.28349 5.95026 8.01495C5.955 7.74641 6.01378 7.48157 6.12309 7.23624C6.2324 6.99091 6.39001 6.77011 6.5865 6.58701M11.9598 11.9603C10.8202 12.829 9.43258 13.3103 7.99984 13.3337C3.33317 13.3337 0.666504 8.00034 0.666504 8.00034C1.49576 6.45494 2.64593 5.10475 4.03984 4.04034L11.9598 11.9603ZM6.59984 2.82701C7.05873 2.7196 7.52855 2.6659 7.99984 2.66701C12.6665 2.66701 15.3332 8.00034 15.3332 8.00034C14.9285 8.75741 14.4459 9.47017 13.8932 10.127L6.59984 2.82701Z",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 0.666992L15.3332 15.3337",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeInvisible);
export default __webpack_public_path__ + "static/media/eye-invisible.2c615570fa17f62a8a8ab0273737d83c.svg";
export { ForwardRef as ReactComponent };